import { cn } from '@simplywallst/ui-core/next';

type Props = {
  trackColor?: string;
} & Omit<React.HTMLProps<HTMLInputElement>, 'type'>;

const baseClasses = cn([
  'w-full',
  'h-x0_5',
  'py-x0_25',
  'px-0',
  'appearance-none',
  'rounded-[5px]',
  'bg-no-repeat',
  'bg-p-white-170',
  'slider-thumb:appearance-none',
  'slider-thumb:h-5',
  'slider-thumb:w-5',
  'slider-thumb:bg-p-white-100',
  'slider-thumb:rounded-full',
  'slider-thumb:transition-all',
  'slider-thumb:cursor-grab',
  'slider-track:appearance-none',
  'slider-track:shadow-none',
  'slider-track:border-none',
  'slider-track:bg-[transparent]',
  'slider-track:cursor-pointer',
  'hover:slider-thumb:shadow-[0px_0px_0px_8px_var(--s-color-p-white-130)]',
  'active:slider-thumb:shadow-[0px_0px_0px_11px_var(--s-color-p-white-130)]',
]);

export const InputRange = ({
  trackColor,
  style,
  className,
  ...props
}: Props) => {
  return (
    <input
      {...props}
      type="range"
      className={cn(baseClasses, className)}
      style={{
        background: trackColor,
      }}
    />
  );
};
